function Home() {
    return (
      <div>
        <h1>Liaisons Habitat</h1>
      </div>
    );
  }
  
  export default Home;
  